import axios from "axios";
import { domain } from "../Links/Links";

export async function shoppingCartRequest(setData, setLoadingStatus) {
    setLoadingStatus(true);

    const response = await axios.get(domain + '/shopping_cart/', {
        withCredentials: true,
    })

    if (response.data) {
        setData(response.data);
        setLoadingStatus(false);
    }
}